import { getPathCartProductUtil } from 'models/daos/cart-product/utils'
import { API_METHOD } from 'modules/api/constants'
import openSuccessBannerAction from 'modules/banner/actions/open-success'
import {
  CART_PRODUCTS_DOMAIN,
  CART_PRODUCTS_ENDPOINT,
  CART_PRODUCTS_STATE
} from 'modules/cart-products/constants'
import openModalAction from 'modules/modal/actions/open'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'
import { loadNotificationsAction } from 'modules/notifications/actions/load'
import { deleteLegacyReduxAction } from 'modules/redux/actions/legacy/delete'
import { saveLegacyReduxAction } from 'modules/redux/actions/legacy/save'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'
import REDUX_OPTION from 'modules/redux/constants/option'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import { resetShippingAction } from 'modules/shipping/actions/reset'
import { getObjectUtil } from 'packages/src'

/**
 * Resets the domain to its initial state.
 * @returns {Function}
 */
function resetCartProductAction () {
  const path = CART_PRODUCTS_DOMAIN
  const value = CART_PRODUCTS_STATE
  return updateLegacyReduxAction({
    path,
    value
  })
}

/**
 * Removes the given CartProduct from the cart.
 * @param  {number} id
 * @returns {Function}
 */
function delCartProductAction (id) {
  return (dispatch, getState) => {
    // Get the `State`
    const state = getState()
    // Get the `CartProduct`
    const path = getPathCartProductUtil(id)
    const cartProduct = getObjectUtil(state, path)
    // Get the `Product`
    const productPath = getPathReduxUtil(cartProduct.data.product)
    const product = getObjectUtil(state, productPath)
    // Get the delete endpoint
    const endpoint = CART_PRODUCTS_ENDPOINT.DELETE
    dispatch(
      deleteLegacyReduxAction({
        path,
        endpoint
      })
    )
      .then(() => {
        // Show a banner message
        dispatch(
          openSuccessBannerAction(
            `${product.data.name} was successfully removed from your cart.`,
            () => dispatch(
              openModalAction(MODAL_ID.CHECKOUT)
            )
          )
        )
        dispatch(loadNotificationsAction({
          [REDUX_OPTION.FORCED]: true,
          [REDUX_OPTION.RESETTING]: true
        }))
        // Reset the shipping options
        dispatch(resetShippingAction())
      })
  }
}

/**
 * Gets the product quantity of a given cartProduct.
 * @param  {CartProduct} cartProduct
 * @param  {DomainMapData} productQuantityData
 * @returns {ProductQuantity}
 */
function getProductQuantity (cartProduct, productQuantityData) {
  const associatedProductQuantities = getObjectUtil(
    cartProduct, 'data.product.data.productQuantities'
  )
  const productQuantities = associatedProductQuantities.map(associationProductQuantity =>
    productQuantityData[associationProductQuantity.data.id]
  )
  const name = Object.values(cartProduct.data.data)[0]
  return productQuantities.find(productQuantity =>
    productQuantity.data.name === name
  )
}

/**
 * Updates a CartProduct quantity.
 * @param  {Number} id
 * @param  {Object} updates
 * @returns {Function}
 */
function updateCartProductAction (id, updates) {
  return (dispatch, getState) => {
    // Get the `CartProduct`
    const path = getPathCartProductUtil(id)
    const cartProduct = getObjectUtil(getState(), path)
    // Get the `Product`
    const productPath = getPathReduxUtil(cartProduct.data.product)
    const product = getObjectUtil(getState(), productPath)
    // Get the `ProductQuantity`
    const productQuantity = getProductQuantity(
      cartProduct,
      getState().productQuantities.data
    )
    // Get the data to send
    const data = {
      id,
      productId: product.data.id,
      productQuantityId: productQuantity.data.id,
      ...cartProduct.data.data,
      ...updates
    }
    // Update the CartProduct
    const endpoint = CART_PRODUCTS_ENDPOINT.UPDATE
    const method = API_METHOD.POST
    dispatch(saveLegacyReduxAction({
      path,
      endpoint,
      method,
      data
    }))
      .then(() => {
        dispatch(
          openSuccessBannerAction(
            'Quantity successfully updated',
            () => dispatch(
              openModalAction(MODAL_ID.CHECKOUT)
            )
          )
        )
        dispatch(loadNotificationsAction({
          isForced: true
        }))
        dispatch(resetShippingAction())
      })
  }
}

export {
  delCartProductAction,
  resetCartProductAction,
  updateCartProductAction
}
